var e = "_placeholder_1m5pt_1",
  l = "_placeholderItem_1m5pt_8",
  d = "_placeholderDisabled_1m5pt_12",
  o = "_placeholderHidden_1m5pt_16",
  a = {
    placeholder: e,
    placeholderItem: l,
    placeholderDisabled: d,
    placeholderHidden: o
  };
export { a as default, e as placeholder, d as placeholderDisabled, o as placeholderHidden, l as placeholderItem };